// import React from "react";
// import { Link } from "react-router-dom";
// import { FileText, Award, Code2, GraduationCap, Briefcase, Trophy, Boxes, Building2, Archive, ArrowUpRight } from "lucide-react";
// import Reveal, { SectionLabel } from "../components/Reveal";
// import { Helmet } from "react-helmet-async";

// <Helmet>
// <title>
// Services | JustZeta
// </title>

// <meta
// name="description"
// content="Conference certificate storage, hackathon archives, course certificates, workshop preservation, research paper storage and institutional archives."
// />
// <meta property="og:type" content="website" />

// <meta property="og:site_name" content="JustZeta" />

// <meta property="og:title"
// content="JustZeta - Secure Digital Certificate Preservation"
// />

// <meta property="og:description"
// content="Long-term preservation of digital certificates and research papers."
// />

// <meta property="og:image"
// content="https://justzeta.com/logo.png"
// />

// <meta property="og:url"
// content="https://justzeta.com"
// />
// <meta name="twitter:card" content="summary_large_image"/>

// <meta
// name="twitter:title"
// content="JustZeta"
// />

// <meta
// name="twitter:description"
// content="Secure digital certificate preservation."
// />

// <meta
// name="twitter:image"
// content="https://justzeta.com/logo.png"
// />
// <link
// rel="canonical"
// href="https://justzeta.com/services"
// />
// </Helmet>
// const services = [
//   { icon: Award, title: "Conference Certificate Storage", tag: "Conferences", desc: "Every presenter, delegate and chair gets an archived, verifiable record — for the lifetime of the conference series." },
//   { icon: Code2, title: "Hackathon Certificate Storage", tag: "Hackathons", desc: "Preserve winner and participant certificates from every edition in one durable roster." },
//   { icon: GraduationCap, title: "Course Certificate Storage", tag: "Courses", desc: "Online and offline course providers issue certificates with retention guarantees that outlive their platform." },
//   { icon: Briefcase, title: "Workshop Certificate Storage", tag: "Workshops", desc: "Short workshops, long memories. Attendees can retrieve their certificate years later." },
//   { icon: Building2, title: "Internship Certificate Storage", tag: "Internships", desc: "Companies preserve internship credentials that interns will need at future employers." },
//   { icon: Trophy, title: "Competition Certificate Storage", tag: "Competitions", desc: "From coding contests to olympiads — every ranked participant, permanently on record." },
//   { icon: FileText, title: "Conference Paper PDF Preservation", tag: "Research", desc: "Attach each presenter's research paper to their certificate. Both preserved together, forever linked." },
//   { icon: Boxes, title: "Bulk Institutional Storage", tag: "Institutions", desc: "Universities and government bodies onboard 10,000+ records via bulk import in a single afternoon." },
//   { icon: Archive, title: "Long-Term Digital Archive", tag: "Archive", desc: "The umbrella tier for any organisation looking to consolidate historical certificates from previous years." },
// ];

// export default function Services() {
//   return (
//     <div data-testid="page-services">
//       <section className="border-b border-white/10 py-24 md:py-10">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <SectionLabel index={1}>Services</SectionLabel>
//           <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
//             <h1 className="lg:col-span-8 font-serif-display text-5xl md:text-7xl leading-[1.02]">
//               Nine archival services. <br />
//               <span className="italic text-neutral-500">One preservation guarantee.</span>
//             </h1>
//             <p className="lg:col-span-4 text-neutral-400 leading-relaxed">
//                 Whether you're organizing a conference, hackathon, course,
//   internship or workshop, JustZeta securely preserves digital
//   certificates and research papers for years with easy retrieval
//   and verification.
//             </p>
//           </div>
//         </div>
//       </section>
// <section className="border-b border-white/10 py-24">
//   <div className="max-w-7xl mx-auto px-6 md:px-10">

//     <SectionLabel>How it Works</SectionLabel>

//     <div className="grid md:grid-cols-4 gap-8 mt-16">

//       <div>
//         <div className="text-[#e60000] text-5xl font-serif-display">
//           01
//         </div>

//         <h3 className="text-2xl mt-6 font-serif-display">
//           Upload
//         </h3>

//         <p className="text-neutral-400 mt-4">
//           Upload certificates and research papers securely.
//         </p>
//       </div>

//       <div>
//         <div className="text-[#e60000] text-5xl font-serif-display">
//           02
//         </div>

//         <h3 className="text-2xl mt-6 font-serif-display">
//           Organize
//         </h3>

//         <p className="text-neutral-400 mt-4">
//           Records are indexed by event, year and participant.
//         </p>
//       </div>

//       <div>
//         <div className="text-[#e60000] text-5xl font-serif-display">
//           03
//         </div>

//         <h3 className="text-2xl mt-6 font-serif-display">
//           Preserve
//         </h3>

//         <p className="text-neutral-400 mt-4">
//           Secure cloud storage keeps every record available throughout the selected retention period.
//         </p>
//       </div>

//       <div>
//         <div className="text-[#e60000] text-5xl font-serif-display">
//           04
//         </div>

//         <h3 className="text-2xl mt-6 font-serif-display">
//           Retrieve
//         </h3>

//         <p className="text-neutral-400 mt-4">
//           Participants can access their records whenever needed.
//         </p>
//       </div>

//     </div>

//   </div>
// </section>
//       <section className="border-b border-white/10 py-24 md:py-10">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/10">
//             {services.map((s, i) => (
//               <Reveal key={s.title} delay={i * 0.04}>
//                 <div
//                   data-testid={`service-card-${i}`}
//                   className="group bg-[#0a0a0a] p-10 h-full hover:bg-[#111] transition-colors flex flex-col"
//                 >
//                   <div className="flex items-center justify-between">
//                     <span className="overline">{s.tag}</span>
//                     <span className="font-mono text-xs text-neutral-600">{String(i + 1).padStart(2, "0")}</span>
//                   </div>
//                   <div className="w-12 h-12 border border-white/10 flex items-center justify-center mt-10 group-hover:border-[#e60000] group-hover:bg-[#e60000]/10 transition-all">
//                     <s.icon size={20} className="text-[#e60000]" strokeWidth={1.5} />
//                   </div>
//                   <h3 className="font-serif-display text-2xl mt-8">{s.title}</h3>
//                   <p className="text-neutral-400 mt-4 leading-relaxed text-[15px]">{s.desc}</p>
//                   <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between">
//                     <Link
//                       to="/pricing"
//                       data-testid={`service-pricing-link-${i}`}
//                       className="text-xs uppercase tracking-[0.22em] text-neutral-400 hover:text-white hover-underline"
//                     >
//                       See pricing
//                     </Link>
//                     <ArrowUpRight size={16} className="text-neutral-600 group-hover:text-[#e60000] transition-colors" />
//                   </div>
//                 </div>
//               </Reveal>
//             ))}
//           </div>
//         </div>
        
//       </section>
// <section className="border-b border-white/10 py-24">
// <div className="max-w-7xl mx-auto px-6">

// <SectionLabel>
// Why Organizations Choose JustZeta</SectionLabel>

// <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">

// <div className="border border-white/10 p-8">

// <h3 className="font-serif-display text-2xl">
// Years of Retention
// </h3>

// <p className="text-neutral-400 mt-4">
// Choose storage periods that match your organization's needs.
// </p>

// </div>

// <div className="border border-white/10 p-8">

// <h3 className="font-serif-display text-2xl">
// Secure Storage
// </h3>

// <p className="text-neutral-400 mt-4">
// Protected cloud infrastructure with encryption in transit and at rest.
// </p>

// </div>

// <div className="border border-white/10 p-8">

// <h3 className="font-serif-display text-2xl">
// Easy Retrieval
// </h3>

// <p className="text-neutral-400 mt-4">
// Certificates remain accessible whenever participants need them.
// </p>

// </div>

// <div className="border border-white/10 p-8">

// <h3 className="font-serif-display text-2xl">
// Research Papers
// </h3>

// <p className="text-neutral-400 mt-4">
// Link conference papers directly to presenter records.
// </p>

// </div>

// </div>

// </div>
// </section>
//       <section className="py-24 md:py-10">
//         <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
//           <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.02]">
//             Not sure which fits <span className="italic text-neutral-500">your event?</span>
//           </h2>
//           <p className="mt-6 text-neutral-400 max-w-2xl mx-auto">
//             Send us your event outline and expected participant count — we'll recommend the
//             optimal service, retention window and pricing tier.
//           </p>
//           <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
//             <Link
//               to="/contact"
//               data-testid="services-cta-contact"
//               className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3"
//             >
//               Talk to us <ArrowUpRight size={18} />
//             </Link>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

import React from "react";
import { Link } from "react-router-dom";
import { FileText, Award, Code2, GraduationCap, Briefcase, Trophy, Boxes, Building2, Archive, ArrowUpRight, Rocket } from "lucide-react";
import Reveal, { SectionLabel } from "../components/Reveal";
import { Helmet } from "react-helmet-async";


const services = [
  { icon: Award, title: "Conference Certificate Management", tag: "Conferences", desc: "Generate and manage verifiable certificates for presenters, delegates, and chairs across your entire conference series." },
  { icon: Code2, title: "Hackathon Certificate Management", tag: "Hackathons", desc: "Issue and organize winner and participant certificates from every hackathon edition in one dynamic dashboard." },
  { icon: GraduationCap, title: "Course Certificate Management", tag: "Courses", desc: "Equip course providers with automated certificate generation and secure verification that scales with their platform." },
  { icon: Briefcase, title: "Workshop Certificate Management", tag: "Workshops", desc: "Distribute workshop certificates effortlessly. Attendees can securely download and verify their credentials at any time." },
  { icon: Building2, title: "Internship Certificate Management", tag: "Internships", desc: "Help companies issue authentic internship credentials that interns can easily share and future employers can instantly verify." },
  { icon: Trophy, title: "Competition Certificate Management", tag: "Competitions", desc: "From coding contests to olympiads — map participant data to custom templates and issue verifiable records to every ranked competitor." },
  { icon: FileText, title: "Research Paper Display", tag: "Research", desc: "Attach each presenter's research paper PDF directly to their certificate. Visitors can view the paper alongside the verified credential." },
  { icon: Boxes, title: "Bulk Certificate Generation", tag: "Institutions", desc: "Universities and government bodies can generate and issue 10,000+ certificates via bulk CSV import in a single afternoon." },
  { icon: Archive, title: "Complete Event Management", tag: "Events", desc: "The comprehensive tier for any organization looking to consolidate certificate generation and verification for multiple events." },
  { icon: Rocket, title: "Marathon & Tournament Certificates", tag: "Sports", desc: "Issue verifiable finisher and winner certificates for marathons, esports, and competitive sports tournaments." },
];

export default function Services() {
  return (
    <div data-testid="page-services">
      <Helmet>
        <title>Services | JustZeta</title>
        <meta
          name="description"
          content="Generate, manage, and verify certificates for conferences, hackathons, courses, workshops, internships, and institutional events."
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="JustZeta" />
        <meta
          property="og:title"
          content="JustZeta - Certificate Management Platform"
        />
        <meta
          property="og:description"
          content="Generate, manage, and verify digital certificates and research papers from a single platform."
        />
        <meta property="og:image" content="https://justzeta.com/logo.png" />
        <meta property="og:url" content="https://justzeta.com/services" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="JustZeta" />
        <meta
          name="twitter:description"
          content="The complete certificate management solution for organizations."
        />
        <meta name="twitter:image" content="https://justzeta.com/logo.png" />
        <link rel="canonical" href="https://justzeta.com/services" />
      </Helmet>

      <section className="border-b border-white/10 py-24 md:py-10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index={1}>Services</SectionLabel>
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <h1 className="lg:col-span-8 font-serif-display text-5xl md:text-7xl leading-[1.02]">
              Nine management solutions. <br />
              <span className="text-[#e60000]">One comprehensive platform.</span>
            </h1>
            <p className="lg:col-span-4 text-neutral-400 leading-relaxed">
              Whether you're organizing a conference, hackathon, course,
              internship, or workshop, JustZeta helps you generate, manage, and verify
              digital certificates and research papers with seamless access and instant QR authentication.
            </p>
          </div>
        </div>
      </section>

      <section className="border-b border-white/10 py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel>How it Works</SectionLabel>
      <div className="grid md:grid-cols-4 gap-8 mt-16">
            <div>
              <div className="text-[#e60000] text-5xl font-serif-display">01</div>
              <h3 className="text-2xl mt-6 font-serif-display">Onboarding</h3>
              <p className="text-neutral-400 mt-4">
                Submit your request for onboarding. We verify your organization to ensure platform integrity.
              </p>
            </div>
            <div>
              <div className="text-[#e60000] text-5xl font-serif-display">02</div>
              <h3 className="text-2xl mt-6 font-serif-display">Create Event</h3>
              <p className="text-neutral-400 mt-4">
                Configure your event and seamlessly import all your participant details.
              </p>
            </div>
            <div>
              <div className="text-[#e60000] text-5xl font-serif-display">03</div>
              <h3 className="text-2xl mt-6 font-serif-display">Template Structure</h3>
              <p className="text-neutral-400 mt-4">
                Finalize the structure using your own design or one of our formal, predefined templates.
              </p>
            </div>
            <div>
              <div className="text-[#e60000] text-5xl font-serif-display">04</div>
              <h3 className="text-2xl mt-6 font-serif-display">Issue & Verify</h3>
              <p className="text-neutral-400 mt-4">
                Distribute the records. Anyone can verify authenticity using embedded QR codes for years.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="border-b border-white/10 py-24 md:py-10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/10">
            {services.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.04}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group bg-[#0a0a0a] p-10 h-full hover:bg-[#111] transition-colors flex flex-col"
                >
                  <div className="flex items-center justify-between">
                    <span className="overline">{s.tag}</span>
                    <span className="font-mono text-xs text-neutral-600">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <div className="w-12 h-12 border border-white/10 flex items-center justify-center mt-10 group-hover:border-[#e60000] group-hover:bg-[#e60000]/10 transition-all">
                    <s.icon size={20} className="text-[#e60000]" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-serif-display text-2xl mt-8">{s.title}</h3>
                  <p className="text-neutral-400 mt-4 leading-relaxed text-[15px]">
                    {s.desc}
                  </p>
                  <div className="mt-8 pt-6 border-t border-white/10 flex items-center justify-between">
                    <Link
                      to="/pricing"
                      data-testid={`service-pricing-link-${i}`}
                      className="text-xs uppercase tracking-[0.22em] text-neutral-400 hover:text-white hover-underline"
                    >
                      See pricing
                    </Link>
                    <ArrowUpRight
                      size={16}
                      className="text-neutral-600 group-hover:text-[#e60000] transition-colors"
                    />
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="border-b border-white/10 py-24">
        <div className="max-w-7xl mx-auto px-6">
          <SectionLabel>Why Organizations Choose JustZeta</SectionLabel>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
            <div className="border border-white/10 p-8">
              <h3 className="font-serif-display text-2xl">Long-Term Access</h3>
              <p className="text-neutral-400 mt-4">
                Provide participants with guaranteed access to download their certificates for up to 50 years based on your selected plan.
              </p>
            </div>
            <div className="border border-white/10 p-8">
              <h3 className="font-serif-display text-2xl">Custom Templates</h3>
              <p className="text-neutral-400 mt-4">
                Upload your own custom certificate designs and automatically overlay bulk participant details.
              </p>
            </div>
            <div className="border border-white/10 p-8">
              <h3 className="font-serif-display text-2xl">QR Verification</h3>
              <p className="text-neutral-400 mt-4">
                Every generated certificate includes a secure QR code for instant, third-party authentication.
              </p>
            </div>
           <div className="border border-white/10 p-8">
              <h3 className="font-serif-display text-2xl">Research Papers</h3>
              <p className="text-neutral-400 mt-4">
                Display conference research papers alongside certificates (provided the copyright document is submitted).
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-10">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.02]">
            Not sure which fits <span className="text-[#e60000]">your event?</span>
          </h2>
          <p className="mt-6 text-neutral-400 max-w-2xl mx-auto">
            Send us your event outline and expected participant count — we'll recommend the
            optimal setup, access duration, and pricing tier for your organization.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              data-testid="services-cta-contact"
              className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3"
            >
              Talk to us <ArrowUpRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}